import {
  Assessment,
  IObject,
  TprmQuestionnaireTemplate,
  TprmQuestionnaireTemplateId,
  TprmQuestionnaireTemplateMin,
} from "../../Types";
import {invalidateQueries, q} from "../../state";
import jsonApi from "../jsonApi";

export async function list(): Promise<TprmQuestionnaireTemplateMin[]> {
  return jsonApi.get("/tprm/questionnaire_templates");
}

export async function get(questionnaireTemplateId: TprmQuestionnaireTemplateId): Promise<TprmQuestionnaireTemplate> {
  return jsonApi.get(`/tprm/questionnaire_templates/${questionnaireTemplateId}`);
}

export async function delete_(questionnaireTemplateId: TprmQuestionnaireTemplateId): Promise<void> {
  await jsonApi.delete_<Assessment>(`/tprm/questionnaire_templates/${questionnaireTemplateId}`);
  await invalidateQueries([q.tprm.questionnaireTemplates.filter()]);
}

export async function updateName(questionnaireTemplateId: TprmQuestionnaireTemplateId, name: string): Promise<string> {
  const res = await jsonApi.post<"ok">(`/tprm/questionnaire_templates/${questionnaireTemplateId}/name`, name);
  await invalidateQueries([
    q.tprm.questionnaireTemplate.filter(questionnaireTemplateId),
    q.tprm.questionnaireTemplates.filter(),
  ]);
  return res;
}

export async function createFromPreset(templates: IObject[]): Promise<"ok"> {
  const res = await jsonApi.post<"ok">(`/tprm/questionnaire_templates/create_from_preset`, templates);
  await invalidateQueries([q.tprm.questionnaireTemplates.filter()]);
  return res;
}
